export enum DocumentState {
  Pending,
  Printed,
  Rejected,
  Uploaded,
  SignedRejected,
  Approved,
  ArchivePending,
  Archived,
}
